import { provinces } from '../utils/provinces.js';

(function () {
  const form = document.querySelector('.professional-registration form[novalidate]');
  if (!form) return;

  const fileContainer = document.getElementById('file-upload-container');
  const addMoreBtn = document.getElementById('add-more-files');
  const countrySelect = document.getElementById('country');
  const provinceSelect = document.getElementById('province');
  const fileTemplate = document.getElementById('file-upload-template');

  if (countrySelect && provinceSelect) {
    countrySelect.addEventListener('change', function () {
      const country = this.value;

      provinceSelect.replaceChildren();

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      placeholder.textContent = 'Select option';

      provinceSelect.appendChild(placeholder);

      if (provinces[country]) {
        provinces[country].forEach(p => {
          const option = document.createElement('option');
          option.value = p.code;
          option.textContent = p.name;
          provinceSelect.appendChild(option);
        });
      }
    });
  }

  function initFileInput(container) {
    if (!container) return;

    const input = container.querySelector('[data-file-input]');
    const text = container.querySelector('[data-file-text]');
    const iconUpload = container.querySelector('[data-file-icon-upload]');
    const removeBtn = container.querySelector('[data-file-remove]');

    if (input && text) {
      input.addEventListener('change', function () {
        if (this.files && this.files[0]) {
          text.textContent = this.files[0].name;
          text.classList.remove('form-file-placeholder');
          text.classList.add('form-file-name');
          if (iconUpload) iconUpload.classList.add('hidden');
          if (removeBtn) removeBtn.classList.remove('hidden');
        }
      });
    }

    if (removeBtn && input && text) {
      removeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        input.value = '';
        text.textContent = 'Upload';
        text.classList.add('form-file-placeholder');
        text.classList.remove('form-file-name');
        if (iconUpload) iconUpload.classList.remove('hidden');
        removeBtn.classList.add('hidden');
      });
    }
  }

  if (fileContainer) {
    const firstFileItem = fileContainer.querySelector('.file-upload-item');
    if (firstFileItem) {
      initFileInput(firstFileItem);
    }
  }

  if (addMoreBtn && fileContainer && fileTemplate) {
    addMoreBtn.addEventListener('click', function () {
      const clone = fileTemplate.content.cloneNode(true);
      const newItem = clone.querySelector('.file-upload-item');

      fileContainer.appendChild(clone);
      initFileInput(newItem);
    });
  }

  function validateForm() {
    let isValid = true;

    form.querySelectorAll('.is-error').forEach(el => el.classList.remove('is-error'));
    form.querySelectorAll('.form-error').forEach(el => el.remove());

    form.querySelectorAll('[required]').forEach(field => {
      if (!field.value.trim()) {
        isValid = false;
        field.classList.add('is-error');
        const errorMsg = document.createElement('span');
        errorMsg.className = 'form-error';
        errorMsg.textContent = 'Required field';
        const fieldContainer = field.closest('.form-field');
        if (fieldContainer) fieldContainer.appendChild(errorMsg);
      }
    });

    const emailField = form.querySelector('#email');
    if (
      emailField &&
      emailField.value &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailField.value)
    ) {
      isValid = false;
      emailField.classList.add('is-error');
      const errorMsg = document.createElement('span');
      errorMsg.className = 'form-error';
      errorMsg.textContent = 'Please enter a valid email';
      const fieldContainer = emailField.closest('.form-field');
      if (fieldContainer) fieldContainer.appendChild(errorMsg);
    }

    return isValid;
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (!validateForm()) return;

    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn ? submitBtn.textContent : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
    }

    try {
      await new Promise(resolve => setTimeout(resolve, 1000));

      document.getElementById('form-success')?.classList.remove('hidden');
      document.getElementById('form-error')?.classList.add('hidden');

      form.reset();

      if (provinceSelect) {
        provinceSelect.replaceChildren();

        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        placeholder.textContent = 'Select option';

        provinceSelect.appendChild(placeholder);
      }
    } catch {
      document.getElementById('form-error')?.classList.remove('hidden');
      document.getElementById('form-success')?.classList.add('hidden');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    }

  });
})();
